import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import configureStore from './store/configureStore'
import App from './App'
import { actionCreators as globalActions } from './store/Global'
import { Localization, SettingsStore } from 'traveldesk-ui'
import 'dotenv/config'
export const GLOBAL_SETTINGS = {
    GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? ""
}
// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string
const history = createBrowserHistory({ basename: baseUrl })

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history)
store.dispatch(globalActions.initialize() as any)
store.dispatch(Localization.actionCreators.initialize() as any)
// store.dispatch(SettingsStore.actionCreators.setDataTableExportExcelEndpoint("https://supplier.traveldesk.me/api/excel/export"))
history.listen((location, action) => {
    store.dispatch(globalActions.setPath(location.pathname))
})
ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>,
    document.getElementById('main'),
)

// registerServiceWorker()
